import React, {useState, useEffect, Fragment} from 'react'
import {Button, Card, Col, Container, Form, Row, Toast, Modal} from 'react-bootstrap'
import { MdAccountBox } from "react-icons/md";
import { GiLetterBomb, GiMoneyStack } from "react-icons/gi";
import { BsFillCalculatorFill } from "react-icons/bs";
import { BsBank } from "react-icons/bs";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { AiOutlineFileSearch } from "react-icons/ai";
import {useDispatch, useSelector} from 'react-redux'
import { ReasignarResponsableComponent, ContactoTerceroComponent, CambioTipoGestionComponent,SolicitudDescuentoComponent , TrazabilidadHitosComponent, AntecedentesJudicialesComponent,CartaCIAComponent, CarpetaDigitalComponent} from 'reccol-caso-general'
import { ConsultaProcesosJudicialesComponent, ConsultaGastosHonorariosComponent, ConsultaContactoImplicadoComponent } from 'defcol-caso-general';
import { obtenerDatosGestionImplicado} from '../../store/actions/encargado-compania-action'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import {makeStyles} from '@material-ui/core/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import Bitacora from '../bitacora';
import { formatoMonto, isValidParam } from '../../common/Formatos';
import Mensajes from '../mensajes';

const useStyles = makeStyles((theme) => ({
    root: {
     height: 380,
      transform: 'translateZ(0px)',
      flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '10px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */        
    },
    menu: {
      width: '50px',
      height: '50px'      
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
const Antecedentes = ({formik,setIsAnular,setIsReasignar,setShowToast, showToast,showReasignar,handleCloseReasignar}) => {
const {state}=useLocation()
const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
const history =useNavigate()

const classes = useStyles();   
const classesTooltip = useStylesToltip();
const [idGestionAnalista,setIdGestionAnalista]=useState('')
const [comentario,setComentario]=useState('')
const [showCambiar, setShowCambiar] = useState(false) 
  
const [open, setOpen] = React.useState(false);
const [hidden, setHidden] = React.useState(false);
const [showContacto, setShowContacto] = useState(false)
const [showCIA, setShowCIA] = useState(false)
const [showSolicitud, setShowSolicitud] = useState(false)
const [showAntecedentes, setShowAntecedentes] = useState(false)
const [showTraza, setShowTraza] = useState(false)
const [showBitacora, setShowBitacora] = useState(false)
const [showCarpeta, setShowCarpeta] = useState(false)

const handleShowBitacora = () => setShowBitacora(true)
const handleCloseBitacora= () => setShowBitacora(false)
const handleCloseCarpeta= () => setShowCarpeta(false)

  const handleCloseContacto= () => setShowContacto(false)
  const handleCloseCIA = () => setShowCIA(false)
  const handleCloseSolicitud = () => setShowSolicitud(false)
  const handleCloseAntecedentes = () => setShowAntecedentes(false)
  const handleCloseTraza = () => setShowTraza(false)
  

  const handleShowCarpeta= () => setShowCarpeta(true)
  const handleShowContacto= () => setShowContacto(true)
  const handleShowCIA = () => setShowCIA(true)
  const handleShowSolicitud = () => setShowSolicitud(true)
  const handleShowAntecedentes = () => setShowAntecedentes(true)
  const handleShowTraza = () => setShowTraza(true)
  
  const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
  const handleShowProcesosJudiciales = () => setShowProcesosJudiciales(true)

  const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
  const handleShowGastosHonorarios = () => setShowGastosHonorarios(true)

  const [showContactoImplicado, setShowContactoImplicado] = useState(false);
  const handleShowContactoImplicado = () => setShowContactoImplicado(true)
  
  const dispatch = useDispatch()
   
  const handleCloseCambiar = () => {
    if(llaves){
        let query = Buffer.from(JSON.stringify({
            "idCaso": llaves && llaves["idCaso"],
            "idImplicado": llaves && llaves["idImplicado"]
        })).toString('base64')
        dispatch(obtenerDatosGestionImplicado(query)).then(()=>setShowCambiar(false))
    }
    
    
  }
  const handleShowCambiar = () => setShowCambiar(true)
  const handleOpen = () => {
    setOpen(true);
  };
  const handleCloseAction = () => {
    setOpen(false);
  };
  const handleAction = (action) => {
    if(action ==="14_10"){
        handleShowContactoImplicado() 

    } else if(action ==="14_11"){
      
        handleShowCIA()       
    } else if(action ==="14_12"){
      
        handleShowSolicitud()             
    } else if(action ==='14_13'){
     
        handleShowProcesosJudiciales() 
    } else if(action ==='14_14'){
     
      handleShowTraza() 
    } else if(action ==='14_23'){
     
        handleShowGastosHonorarios() 
     }   
  };

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves, cfg_form23, datosGestionImplicado,comboGestion,respuestaProcesar,montosInformados} = data_encargado

    useEffect(()=>{
        if(respuestaProcesar && respuestaProcesar.respuestaProcesar["code"]===1){
           setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),2000)      
        }
    },[respuestaProcesar])

    const actions = [
        
        { icon: <AiOutlineFileSearch  size={30} style={{color:'#00aeab'}}/>, name: cfg_form23 && cfg_form23.cfg_form23['cierraanula-menu-lateral-hitos' ],id:'14_14'},
        { icon: <BsFillCalculatorFill  size={30} style={{color:'#00aeab'}}/>, name:cfg_form23 && cfg_form23.cfg_form23['cierraanula-menu-lateral-dcto'],id:'14_12' },
        { icon: <GiLetterBomb  size={40} style={{color:'#00aeab'}}/>, name: cfg_form23 && cfg_form23.cfg_form23['cierraanula-menu-lateral-carta'],id:'14_11' },
        { icon: <GiMoneyStack  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form23 ? cfg_form23.cfg_form23['cierraanula-menu-lateral-gastos']:'', id:'14_23'} ,
        {  icon: <BsBank  size={30} style={{color:'#00aeab'}}/>, name: cfg_form23 && cfg_form23.cfg_form23['cierraanula-menu-lateral-antecjud'] ,id:'14_13'},
        {  icon: <MdAccountBox  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form23 && cfg_form23.cfg_form23['cierraanula-menu-lateral-ctotro'], id:'14_10'} ,
       
      ];
      const handleCloseToast = () => {
        setShowToast(false);
      }
       return (
        <>
            <style type='text/css'>
        {`
        .cardHeader {
            background-color: #77789b;
            color: #FFFFFF;
          }
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />

      <Modal show={showCambiar} onHide={handleCloseCambiar} size='xl'>
        <CambioTipoGestionComponent handleClose={handleCloseCambiar} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>
      <Modal show={showReasignar} onHide={handleCloseReasignar} size='xl'>
        <ReasignarResponsableComponent handleClose={handleCloseReasignar} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>
      {llaves && <Modal show={showContacto} onHide={handleCloseContacto} size='xl'>
        <ContactoTerceroComponent handleClose={handleCloseContacto} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>}
       <Modal show={showCIA} onHide={handleCloseCIA} size='xl'>
        <CartaCIAComponent handleClose={handleCloseCIA} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={8600399880}
        />
          
      </Modal>
      <Modal show={showSolicitud} onHide={handleCloseSolicitud} size='xl'>
        <SolicitudDescuentoComponent handleClose={handleCloseSolicitud} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>
      <Modal show={showAntecedentes} onHide={handleCloseAntecedentes} size='xl'>
        <AntecedentesJudicialesComponent handleClose={handleCloseAntecedentes} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>
      <Modal show={showTraza} onHide={handleCloseTraza} size='xl' >
        <TrazabilidadHitosComponent handleClose={handleCloseTraza} 
        idCaso={llaves && llaves['idCaso']}
        idImplicado={llaves && llaves['idImplicado']}
        idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />
          
      </Modal>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
      <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={2}
          
          />  
    </Modal>
    <ConsultaContactoImplicadoComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showContactoImplicado}
          setShowModal={setShowContactoImplicado}
      />
    <ConsultaProcesosJudicialesComponent
        idCaso={llaves?.idCaso}
        idOrgCaso={llaves?.idOrgCaso}
        tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
        showModal={showProcesosJudiciales}
        setShowModal={setShowProcesosJudiciales}
    />
    <ConsultaGastosHonorariosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showGastosHonorarios}
          setShowModal={setShowGastosHonorarios}
    />
    <Container className='mb-4 mt-2 position-relative'>
      <div>

            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                className={classes.speedDial}
                hidden={hidden}
                icon={<AiOutlineMenuUnfold size={30} />}
                onClose={handleCloseAction}
                onOpen={handleOpen}
                open={true}            
            >
            { actions.map((action) => (
                <SpeedDialAction
                    key={action.id}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    className={classes.menu}                
                    onClick={()=>handleAction(action.id)}
                    TooltipClasses={classesTooltip}                
                />            
            ))}
            </SpeedDial>
            </div>

            <Card>
                <Card.Header className='mt-0 mb-0' as='h6'
                    style={
                        {
                            backgroundColor: '#4F517A',
                            color: 'white'
                        }
                }>
                    {
                    cfg_form23 ? cfg_form23.cfg_form23['cierraanula-title-antec'] : ''
                } </Card.Header>
                <Container>
                    <Container> {
                        cfg_form23 ? (
                            <div>

                                <Row>
                                    
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-ambitogest']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['ambitoGestion'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['ambitoGestion'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['ambitoGestion'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['ambitoGestion']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-usrultimohito']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'].usuario
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-fechagest'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'].fechaHitoFormat
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-estado'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['estado'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['estado'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['estado'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['estado']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                   
                                </Row>
                                
                                <Row>
                                    
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-hitogest'] 
                                        } </Form.Label>
                                        <br/>

                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'].glosaHito
                                            : ''}
                                        </Form.Text>
                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-comentario'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosGestionImplicado &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== undefined &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== null &&
                                            datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'] !== ''
                                            ? datosGestionImplicado.datosGestionImplicado[0]['gestionCierre'].comentario
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                   
                                </Row>
                                

                                <Row>
                                    <Col md="12">
                                    <div className='d-flex flex-row justify-content-space-beetwen'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        width:'200px',
                                                    }
                                            }>
                                                {
                                                    cfg_form23.cfg_form23['cierraanula-subtitle-recgest'] 
                                            } </Form.Label>
                                    
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',                                                  
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                   
                                </Row>
                                <Container>
                                <Row>
                                    <Col>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-moneda']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {montosInformados &&
                                            isValidParam(montosInformados.montosInformados[0]['GlosaMoneda']) ? montosInformados.montosInformados[0]['GlosaMoneda'] : '' }                                           
                                        </Form.Text>

                                       </Col>
                                    <Col >
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-mtoneto']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {montosInformados &&
                                            isValidParam(montosInformados.montosInformados[0]['MontoCosto']) ? formatoMonto(montosInformados.montosInformados[0]['MontoCosto']) : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    <Col>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-porcrec']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {montosInformados &&
                                            isValidParam(montosInformados.montosInformados[0]['PorConvenido']) ? montosInformados.montosInformados[0]['PorConvenido'] : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    <Col >
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-lbl-mtorecobro'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {montosInformados &&
                                            isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ? formatoMonto(montosInformados.montosInformados[0]['MontoRecobro']) : '' }                                          
                                        </Form.Text>

                                    </Col>
                                    
                                </Row>
                                </Container>
                        <Row>
                                    
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-cmb-gestionanalista'] +" *"
                                        } </Form.Label>
                                        <br/>
                                        <Form.Select
                                        className='mt-2'
                                        aria-label='Default select example'                       
                                        onChange={(e) => {
                                        formik.handleChange(e)
                                        setIdGestionAnalista(e.target.value)
                                        if(parseInt(e.target.value) ===247005){
                                            setIsAnular(true)
                                        }else{setIsAnular(false)}
                                        if(parseInt(e.target.value) ===247001){
                                            setIsReasignar(true)
                                        }else{setIsReasignar(false)}
                                       
                                        }}
                                        name='idGestionAnalista'
                                        value={(formik.values.idGestionAnalista = idGestionAnalista)}
                                        error={formik.errors.idGestionAnalista}
                                    >
                                        <option value={''}>Seleccione...</option>
                                        {comboGestion &&
                                        comboGestion.comboGestion?.map((c) => (
                                            <option key={c.id} value={c.id}>
                                            {c.nombre}
                                            </option>
                                        ))}
                                    </Form.Select>
                                        {formik.errors.idGestionAnalista ? (
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.idGestionAnalista}
                                        </Form.Text>
                                    ) : (
                                        ''
                                    )}

                                       </Col>
                                    <Col md='6'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form23.cfg_form23['cierraanula-input-comentario'] + " (*)"
                                        } </Form.Label>
                                        <br/>
                                        <Form.Control
                                            as='textarea'
                                            className='mt-2 mb-1'
                                            rows={2}
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                setComentario(e.target.value)
                                            }}
                                            name='comentario'
                                            value={
                                                (formik.values.comentario = comentario)
                                            }
                                            error={formik.errors.comentario}
                                            />
                                            {formik.errors.comentario ? (
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.comentario}
                                            </Form.Text>
                                            ) : (
                                            ''
                                            )}

                                       </Col>
                                   
                                </Row>
                                <Col> 
                                     {respuestaProcesar && 
                                        <Mensajes
                                            showToast={showToast}
                                            handleCloseToast={handleCloseToast}
                                            delay={5000}
                                            responseData={respuestaProcesar?.respuestaProcesar}
                                        ></Mensajes>
                                    }
                                    </Col>
                                </div>
                                
                        ) : null
                    } </Container>
                </Container>        
            <Container>
                <Row className='mt-4'>                    
                    <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-gestion-compania',{state:{queryState}} )}>
                            {cfg_form23 && cfg_form23.cfg_form23["cierraanula-btn-volver"]}
                        </Button>
                        <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
                            {cfg_form23 && cfg_form23.cfg_form23["cierraanula-btn-bitacora"]}
                        </Button>
                        <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                            {cfg_form23 && cfg_form23.cfg_form23["cierraanula-btn-carpeta"]}
                        </Button>
                        <Button className='m-2' variant='cambiar' onClick={handleShowCambiar} name='cambiar'>
                            {cfg_form23 && cfg_form23.cfg_form23["cierraanula-btn-cambiatg"]}
                        </Button>
                        <Button className='m-2' variant='actualizar' type='onSubmit' name='actualizar'>
                            {cfg_form23 && cfg_form23.cfg_form23["cierraanula-btn-procesar"]}
                        </Button>
                    </Col>
                </Row>
            </Container>
            </Card>
            </Container>                        
        </>
    )
}

export default Antecedentes
